/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'mail_fill_blue': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M9.8 8.731l4.154 3.726 1.08.966a1.66 1.66 0 01-.748.177H1.714a1.607 1.607 0 01-.72-.166l1.08-.977 4.132-3.726.634.583a1.714 1.714 0 002.32 0l.64-.583zM.166 3.166l.977.902L5.36 7.954 1.143 11.76l-.966.874A1.66 1.66 0 010 11.886v-8c-.001-.25.055-.497.166-.72zm15.691.04c.095.214.143.445.143.68v8c.001.25-.055.496-.166.72l-.977-.875-4.212-3.777 4.212-3.84 1-.908zM14.286 2.17c.276.002.548.069.794.195L8.39 8.469a.566.566 0 01-.777 0l-5.6-5.155L.96 2.35c.234-.117.493-.178.754-.178h12.572z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
